/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */

import React, { useState } from 'react';
import BaseUrls from '../../../utils/baseUrls';
import { prefixPath } from '../../../utils/helpers';

export type AuthorizeComponentProp = {
    setData: (name:string, credLabel:string)=>void
    roleArn:string;
    providerId:string;
    back:()=>void
}

const AuthorizeComponent = ({
  setData, roleArn, providerId, back,
}:AuthorizeComponentProp) => {
  const [name, setName] = useState('');
  const [credlabel, setCredLabel] = useState('');
  const [nameValidationMessage, setNameValidationMessage] = useState(false as boolean|string);
  const [credlabelValidationMessage, setCredLabelValidationMessage] = useState(false as boolean|string);

  const baseUrl = window.location.origin;
  const theme = BaseUrls.getkey();
  const logo = baseUrl + prefixPath(`/img/${theme}/navLogo.png`);

  const validate = () => {
    let flag = true;
    if (name === '') {
      setNameValidationMessage('Name can not be empty');
      flag = false;
    }
    if (credlabel === '') {
      setCredLabelValidationMessage('Cred Label can not be empty');
      flag = false;
    }
    return flag;
  };
  return (
<>
                <div className="container d-flex justify-content-center mt-4 pt-5">
                    {/* right part starts here */}
                    <section className="col-xl-5 addCloudBody col-lg-5 col-md-7 col-sm-12 p-5">
                        <div className="col-xl-10 mx-auto">
                            <div className="text-center mt-5 mb-4">
                             <img src={logo} className="img-responsive" alt="logo" />
                            </div>
                            <h5 className="mb-5 text-center">Add Tencent Cloud</h5>

                            <div className=" mt-3">
                                <div className=" form-floating cordaversion">
                                    <input
                                        type="text"
                                        className="form-control addCloudField col-11"
                                        placeholder="Secretkey"
                                        value={providerId}
                                        disabled
                                    />
                                    <label htmlFor="floatingPassword" className="form-pswd">
                                        Provider Id
                                    </label>

                                </div>
                            </div>
                            <div className=" mt-3">
                                <div className=" form-floating cordaversion">
                                    <input
                                        type="text"
                                        className="form-control addCloudField col-11"
                                        placeholder="Secretkey"
                                        disabled
                                        value={roleArn}
                                    />
                                    <label htmlFor="floatingPassword" className="form-pswd">
                                        RoleArn
                                    </label>

                                </div>
                            </div>

                            <div className=" mt-3">
                                <div className=" form-floating cordaversion">
                                    <input
                                        type="text"
                                        className={`form-control addCloudField col-11 ${nameValidationMessage ? 'is-invalid' : ''}`}
                                        placeholder="Secretkey"
                                        onChange={(e) => { setName(e.target.value); }}
                                        onFocus={() => { setNameValidationMessage(false); }}
                                    />
                                    <label htmlFor="floatingPassword" className="form-pswd">
                                        Name
                                    </label>

                                </div>
                            </div>
                            {nameValidationMessage !== false && (
                                      <div className="text text-danger text-center">
                                            {nameValidationMessage}
                                      </div>
                            )}

<div className=" mt-3">
                                <div className=" form-floating cordaversion">
                                    <input
                                        type="text"
                                        className={`form-control addCloudField col-11 ${credlabelValidationMessage ? 'is-invalid' : ''}`}
                                        placeholder="Secretkey"
                                        onChange={(e) => { setCredLabel(e.target.value); }}
                                        onFocus={() => { setCredLabelValidationMessage(false); }}
                                    />
                                    <label htmlFor="floatingPassword" className="form-pswd">
                                        Cred Label
                                    </label>

                                </div>
</div>
                            {credlabelValidationMessage !== false && (
                                      <div className="text text-danger text-center">
                                            {credlabelValidationMessage}
                                      </div>
                            )}
                            <div className="mt-4 mb-5  col-xl-12 col-lg-12 col-md-12 text-center">
                                <button type="submit" id="createBtn" className="btn mx-2 comingSoon" onClick={() => { back(); }}>
                                    Back
                                </button>
                                <button type="submit" id="createBtn" className="btn comingSoon" onClick={() => { if (validate()) setData(name, credlabel); }}>
                                    Add Cloud
                                </button>
                            </div>
                        </div>
                    </section>
                    {/* right part ends here */}
                </div>

</>
  );
};

export default AuthorizeComponent;